"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPushPageInfoToDataLayerRawScript = exports.getAccessTypeOnSubscriptionService = exports.getUserSubscriptionTierFromCookies = void 0;
var em_jwt_reader_1 = require("em-jwt-reader");
var constants_1 = require("./../constants/constants");
var dataLayerConstructor_1 = require("./dataLayerConstructor");
/**
 * Takes a string of "cookies" from req.headers.cookie or document.cookie and extracts the user's subscription tier from the "em_at" cookie.
 * @param cookies string from req
 * @returns UserSubscriptionTier value from the cookie, or "anonymous" if not found
 */
var getUserSubscriptionTierFromCookies = function (cookies) {
    var _a, _b;
    // Pull "em_at" cookie and grab the "tier" value from the jwt and use that as the value for the "userSubscriptionTier" property. Default to "anonymous"
    var emAtJwt = (_b = (_a = cookies === null || cookies === void 0 ? void 0 : cookies.split(';').find(function (cookie) { return cookie.trim().startsWith("".concat(constants_1.AUTH_COOKIE_NAME, "=")); })) === null || _a === void 0 ? void 0 : _a.split('=')[1]) === null || _b === void 0 ? void 0 : _b.trim();
    if (!emAtJwt) {
        return 'anonymous';
    }
    var emAtPayload = (0, em_jwt_reader_1.ReadAccessToken)(emAtJwt);
    return (emAtPayload === null || emAtPayload === void 0 ? void 0 : emAtPayload.tier) || 'anonymous';
};
exports.getUserSubscriptionTierFromCookies = getUserSubscriptionTierFromCookies;
/**
 * Because "subscription" services have 2 different views of the same page (aka. AccessType's): "pro" and "freemium", we can determine the access type based on the user's tier.
 *
 * **NOT APPLICABLE** to "public" services, since "logged-in" user can access a "public" service and get a "public" accessType.
 * @param userSubscriptionTier The user's tier from the em_at cookie (either "freemium" or "pro...")
 * @returns access type (i.e. "view") that the service "provides" to current user
 */
var getAccessTypeOnSubscriptionService = function (userSubscriptionTier) {
    return userSubscriptionTier === 'freemium' ? constants_1.DATA_LAYER_TYPE_ACCESS_TYPE__FREEMIUM : constants_1.DATA_LAYER_TYPE_ACCESS_TYPE__PRO;
};
exports.getAccessTypeOnSubscriptionService = getAccessTypeOnSubscriptionService;
/**
 * -----> use <DataLayerScript ...> first if at all possible and only rely on this one as fallback for older NextJs/React projects <------
 *
 * There is a specific issue (tbd) with Public.IKPIs where that script doesn't work. This can be used in its place.
 *
 * @param dataLayerProps - Object - object with the options in DataLayerProps (all optional)
 * @param removePrevious  _(optional)_ defaults to `true`. Set to `false` to keep existing (previously pushed) `em.pageView` events in `window.dataLayer`
 * @output stringified code that pushes formatted options into window.dataLayer
 */
var getPushPageInfoToDataLayerRawScript = function (dataLayerProps, removePrevious) {
    if (removePrevious === void 0) { removePrevious = true; }
    var dataLayer = JSON.stringify((0, dataLayerConstructor_1.getDataLayerProperties)(dataLayerProps));
    return ("window.dataLayer = window.dataLayer || []; " +
        // this check will help us avoid duplicate DL payloads pushed from our services into window.dataLayer
        (removePrevious
            ? // NOTE: gotta keep it in one line to not deal with Unit Test failing because of spaces/new lines
                "let idx = 0; while (idx !== -1) { idx = window.dataLayer.findIndex((obj) => obj.event === \"".concat(constants_1.DATA_LAYER_EVENT_PAGE_VIEW, "\"); if (idx !== -1) { window.dataLayer.splice(idx, 1); } } ")
            : '') +
        "window.dataLayer.push(".concat(dataLayer, "); "));
};
exports.getPushPageInfoToDataLayerRawScript = getPushPageInfoToDataLayerRawScript;
//# sourceMappingURL=dataLayerRawScript.js.map